<template>
  <div class="print-page full-height">
    <table-con>
      <div slot="search">
        <el-form ref="form" :model="queryInfo" size="small" label-width="5rem" label-position="right">
          <el-row :gutter="24">
<!--            <el-col :span="5" class="display-row">
              <div class="query-title">用户姓名:</div>
              <div class="flex1">
                <el-input placeholder="请输入用户姓名" clearable v-model="queryInfo.realName" size="small">
                </el-input>
              </div>
            </el-col>-->
            <el-col :span="7" class="display-row">
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入用户ID" clearable v-model="queryInfo.userName" size="small" @keyup.enter.native="handleQuery">
                </el-input>
              </div>
            </el-col>
            <el-col :span="7" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input placeholder="请输入订单编号" clearable v-model="queryInfo.orderNo" size="small" @keyup.enter.native="handleQuery">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">收件人姓名:</div>
              <div class="flex1">
                <el-input placeholder="请输入收件人姓名" clearable v-model="queryInfo.receiverName" size="small" @keyup.enter.native="handleQuery">
                </el-input>
              </div>
            </el-col>
            <div style="display: flex;justify-content: end;">
              <el-button class="search-btn btn-gray" @click="handleReset">重置 </el-button>
              <el-button class="search-btn btn-blue" @click="handleQuery">搜索</el-button>
            </div>

          </el-row>
        </el-form>
      </div>
      <!-- 表格 -->
      <div slot="table" class="full-height display-col">
        <el-table :height="tableResize.tableHeight"
                  :data="tableList"
                  style="width: 100%;margin-bottom:15px"
                  :header-cell-style="tableStyle.headerStyle"
                  :cell-style="tableStyle.cellStyle" border
                  v-loading="loading">

          <el-table-column label="序号" type="index" align="center" width="50">
            <template slot-scope="scope">
          <span>{{
              (queryInfo.pageNum - 1) * queryInfo.pageSize + scope.$index + 1
            }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="110" align="center" prop="createTime">
            <template slot-scope="scope">
              <div style="width: 100%">
                <div style="width: 100%">
                  {{ parseTime(scope.row.createTime, "{y}-{m}-{d}") }}
                </div>
                <div style="width: 100%">
                  {{ parseTime(scope.row.createTime, "{h}:{i}:{s}") }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="主账号" align="center" prop="clientMasterUserName" />
          <el-table-column label="客户ID" align="center" prop="customerUserName" />
          <el-table-column label="订单号" align="center" prop="goodsCode">
            <template slot-scope="{ row }">
              <div v-for="bundleOrder in row.bundleOrderListThree">
                {{ bundleOrder.orderNo }}
                <span>
                  {{ bundleOrder.orderStatus | orderStatusFilter }}
                </span>
              </div>

              <div v-if="row.bundleOrderList && row.bundleOrderList.length > 3">
                <el-tooltip placement="bottom" effect="light">
                  <template #content>
                    <div v-for="bundleOrder in row.bundleOrderList">
                      {{ bundleOrder.orderNo }}
                      <span>
                        {{ bundleOrder.orderStatus | orderStatusFilter }}
                      </span>
                    </div>
                  </template>
                  <div style="cursor: pointer">...</div>
                </el-tooltip>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="route" align="center" label="线路">
            <template v-slot="scope">
              {{scope.row.route === '1' ? "空运": "海运"}}
            </template>
          </el-table-column>
          <el-table-column prop="companyNameJp" align="center" label="物流公司"></el-table-column>
          <el-table-column label="收货地址" align="center" prop="receiver" min-width="160">
            <template slot-scope="{ row }">
              <div style="text-align: left">
                <div>姓名：{{row.receiverName}}</div>
                <div>电话：{{row.receiverPhone}}</div>
                <div>地址：{{row.receiverAddresserArea + row.receiverAddress}}</div>
                <div>邮编：{{row.receiverZipCode}}</div>
                <!--<div>邮箱：{{row.receiverEmail}}</div>-->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="进口商地址" align="center" prop="clearance"  min-width="160">
            <template slot-scope="{ row }">
              <div style="text-align: left">
                <div>姓名：{{row.senderName}}</div>
                <div>电话：{{row.senderPhone}}</div>
                <div>地址：{{row.senderAddresserArea + row.senderAddress}}</div>
                <div>邮编：{{row.senderZipCode}}</div>
                <!--<div>邮箱：{{row.senderEmail}}</div>-->
              </div>
            </template>
          </el-table-column>

        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
      </div>

    </table-con>
  </div>
</template>

<script>
import { TableResize } from '@/assets/js/utils'
export default {
  name: 'Bundle',
  data() {
    return {
      tableResize: new TableResize(260),
      queryInfo: {
        userName:'',
        realName:'',
        orderNo:'',
        receiverName:'',
        pageNum: 1,
        pageSize: 10,
      },
      total: 10,
      loading: false,
      tableList: [],
    }
  },
  mounted() {
    this.tableResize.onRun()
    // console.log('onRun', this.tableResize)
  },
  destroyed() {
    this.tableResize.onStop()
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const { data: res } = await this.$http.get("/bundle/list", { params: this.queryInfo });
      this.tableList = res.list.map(item => {
        return{
          ...item,
          bundleOrderListThree: item.bundleOrderList.slice(0, 3),
        }
      })
      this.total = res.total
    },
    // 搜索
    handleQuery() {
      this.queryInfo.pageNum = 1
      this.getList()
    },
    // 重置
    handleReset() {
      this.queryInfo.pageNum = 1
      this.queryInfo.userName=''
      this.queryInfo.realName=''
      this.queryInfo.orderNo=''
      this.queryInfo.receiverName=''
      this.getList()
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getList();
    },
    // 日期格式化
    parseTime(time, pattern) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
          time = parseInt(time)
        } else if (typeof time === 'string') {
          time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
        // date = new Date(addHourToTimestamp(time))
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
  }
}
</script>
